/**
 * State for the Segment Data Tables list tab. Intentionally minimal for CR1 (list only):
 * `refreshToken` is the only slice, and it is the seam later CRs use to re-trigger the list
 * fetch (e.g. after Create) without the list view needing to know what changed. List data
 * (tables/loading/error) lives in the service hook's [result, loading, error] tuple per the
 * house pattern, so it is deliberately not mirrored into reducer state.
 */
export interface SegmentTablesState {
    refreshToken: number;
}

export const initialState: SegmentTablesState = {
    refreshToken: 0,
};
